var React = require('react');

function IconAlbumInline (props) {
    return React.createElement("path",props);
}

IconAlbumInline.defaultProps = {"d":"M44.65,28.2 L30.55,28.2 C29.2528,28.2 28.2,29.2528 28.2,30.55 L28.2,44.65 C28.2,45.9472 29.2528,47 30.55,47 L44.65,47 C45.9472,47 47,45.9472 47,44.65 L47,30.55 C47,29.2528 45.9472,28.2 44.65,28.2 M44.65,0 L30.55,0 C29.2528,0 28.2,1.0528 28.2,2.35 L28.2,16.45 C28.2,17.7472 29.2528,18.8 30.55,18.8 L44.65,18.8 C45.9472,18.8 47,17.7472 47,16.45 L47,2.35 C47,1.0528 45.9472,0 44.65,0 M16.45,28.2 L2.35,28.2 C1.0528,28.2 0,29.2528 0,30.55 L0,44.65 C0,45.9472 1.0528,47 2.35,47 L16.45,47 C17.7472,47 18.8,45.9472 18.8,44.65 L18.8,30.55 C18.8,29.2528 17.7472,28.2 16.45,28.2 M16.45,0 L2.35,0 C1.0528,0 0,1.0528 0,2.35 L0,16.45 C0,17.7472 1.0528,18.8 2.35,18.8 L16.45,18.8 C17.7472,18.8 18.8,17.7472 18.8,16.45 L18.8,2.35 C18.8,1.0528 17.7472,0 16.45,0"};

module.exports = IconAlbumInline;

IconAlbumInline.default = IconAlbumInline;
